// Category colors for cost breakdown charts
export const CATEGORY_COLORS: Record<string, string> = {
  Compute: "#2196F3",
  "SQL Warehouse": "#4CAF50",
  "AI/ML": "#9C27B0",
  Lakehouse: "#FF9800",
  Platform: "#607D8B",
};

export const CATEGORIES = ["Compute", "SQL Warehouse", "AI/ML", "Lakehouse", "Platform"];

// Product to category mapping
export const PRODUCT_TO_CATEGORY: Record<string, string> = {
  JOBS: "Compute",
  ALL_PURPOSE: "Compute",
  DLT: "Compute",
  INTERACTIVE: "Compute",
  SQL: "SQL Warehouse",
  SERVERLESS_SQL: "SQL Warehouse",
  MODEL_SERVING: "AI/ML",
  VECTOR_SEARCH: "AI/ML",
  AI_GATEWAY: "AI/ML",
  AI_RUNTIME: "AI/ML",
  AI_FUNCTIONS: "AI/ML",
  FOUNDATION_MODEL_TRAINING: "AI/ML",
  AGENT_EVALUATION: "AI/ML",
  AGENT_BRICKS: "AI/ML",
  DATABASE: "Lakehouse",
  ONLINE_TABLES: "Lakehouse",
  PREDICTIVE_OPTIMIZATION: "Lakehouse",
  LAKEHOUSE_MONITORING: "Lakehouse",
  DATA_QUALITY_MONITORING: "Lakehouse",
  DATA_CLASSIFICATION: "Lakehouse",
  NETWORKING: "Platform",
  BASE_ENVIRONMENTS: "Platform",
  FINE_GRAINED_ACCESS_CONTROL: "Platform",
  APPS: "Platform",
  CLEAN_ROOM: "Platform",
  LAKEFLOW_CONNECT: "Platform",
};

export const getProductCategory = (product: string): string => {
  return PRODUCT_TO_CATEGORY[product] || "Other";
};

// Re-export shared efficiency constants for convenience
export {
  COMPUTE_EFFICIENCY_SCORE_COLORS as EFFICIENCY_COLORS,
  COMPUTE_EFFICIENCY_SCORE_LABELS,
} from "@/pages/sku/constants";

export const getEfficiencyScore = (jobsPct: number): string => {
  if (jobsPct >= 70) return "healthy";
  if (jobsPct >= 50) return "moderate";
  return "unhealthy";
};

export const IMPROVEMENT_TIP =
  "To improve efficiency: 1) Migrate All-Purpose interactive workloads to scheduled Jobs - they're more cost-effective. 2) Review Serverless usage - while convenient, it's more expensive per DBU. Consider standard Jobs clusters for predictable workloads. Target: >70% Jobs usage.";
